module.exports = __webpack_public_path__ + "img/covers-08.3dcaea36.png";